import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import Acknowledgment from "models/interfaces/acknowledgment";

const defaultValues: Acknowledgment =
    RecordUtils.auditableDefaultValuesFactory<Acknowledgment>({
        key: undefined,
        userId: undefined,
        userRoleId: undefined,
    });

export default class AcknowledgmentRecord
    extends Record(defaultValues)
    implements Acknowledgment
{
    constructor(params?: Acknowledgment) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }
        super(params);
    }
}
